module.exports = __webpack_public_path__ + "img/folder-x.1146939f.svg";